import { useMemo } from 'react';
import { VStack, Text, Heading } from '@chakra-ui/react';
import { format } from 'date-fns';

import { ClockIcon, LocationPinIcon } from '../../icons';
import { styles } from '../../../lib';

import type { IEvent } from '../../../lib';

interface IEventDetailsProps {
	event: IEvent;
	isSameDayEvent: boolean;
	eventTooltipTextColor: string;
	monthFormat: string;
	timeFormat: string;
	isListItem: boolean;
	haveFeaturedImage: boolean;
	parentRef: any;
	eventPopoverColor: string;
}

export const EventDetails = ({
	event,
	isSameDayEvent,
	eventTooltipTextColor,
	timeFormat,
	monthFormat,
	isListItem,
	haveFeaturedImage,
	parentRef,
	eventPopoverColor,
}: IEventDetailsProps) => {
	const { iconStyle, lineClampSx } = styles.eventDetailCard;
	const lineClamp = useMemo(() => (isListItem ? lineClampSx : {}), [isListItem, lineClampSx]);
	return (
		<VStack
			ref={parentRef}
			gap={1}
			alignItems='flex-start'
			px={6}
			pt={2}
			pb={6}
			background={haveFeaturedImage ? eventPopoverColor : ''}
			width={isListItem ? 'full' : 'inherit'}
		>
			<Heading
				fontSize={isListItem ? '18px' : '30px'}
				fontWeight='900'
				color={`${eventTooltipTextColor} !important`}
				sx={lineClamp}
			>
				{event.title}
			</Heading>
			<Text
				alignItems='baseline'
				color={eventTooltipTextColor}
				display='flex'
				fontSize='.9rem'
				fontWeight={600}
				m={0}
			>
				<ClockIcon size={12} fill={eventTooltipTextColor} style={iconStyle} />
				{format(event.start, isSameDayEvent ? timeFormat : `${monthFormat} ${timeFormat}`)} -{' '}
				{format(event.end, isSameDayEvent ? timeFormat : `${monthFormat} ${timeFormat}`)}
			</Text>
			{event.venue && (
				<Text
					alignItems='baseline'
					color={eventTooltipTextColor}
					display='flex'
					fontSize='.9rem'
					fontWeight={600}
					m={0}
				>
					<LocationPinIcon size={12} fill={eventTooltipTextColor} style={iconStyle} />
					{event.venue}
				</Text>
			)}
		</VStack>
	);
};
